import { Component } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { AppSettingsService } from 'src/app/settings/services/app-settings.service'
import { VendorService } from '../vendor.service'

@Component({
  selector: 'app-add-vendor',
  templateUrl: './add-vendor.component.html',
  styleUrl: './add-vendor.component.scss'
})
export class AddVendorComponent {
  vendorEmail: string = ''
  firstName: string = ''
  lastName: string = ''
  // storeName: string = ''
  phoneNumber: any;
  userName: string = ''
  storeUrl: string = ''
  vendorPassword: string = ''
  accountName: string = ''
  accountType: string = ''
  bankAdress: string = ''
  iban: string = ''
  accountNumber: string = ''
  bankName: string = ''
  routingNumber: string = ''
  swift: string = ''
  vendorForm: any = this.formBuilder.group({
    firstName: '',
    lastName:'',
    // storeName:'',
    phoneNumber:'',
    userName:'',
    storeUrl:'',
    vendorEmail: '',
    vendorPassword:'',
    accountName:'',
    accountType:'',
    bankAdress:'',
    iban:'',
    accountNumber:'',
    bankName:'',
    routingNumber:'',
    swift:''
  })

   isSubmitting = false; // 
  /** Constructor injects required services */
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public builderService: BuilderService,
    private appSettings: AppSettingsService,
    private appSettingsService: AppSettingsService,
    private vendorService: VendorService
  ) {}

  /** 
   * ngOnInit 
   * Redefine vendorForm with validators to ensure 
   * form fields are properly validated
   */
  ngOnInit(): void {
    this.vendorForm = this.formBuilder.group({
      firstName:['', Validators.compose([Validators.required])],
      lastName: ['', Validators.compose([Validators.required])],
      // storeName: ['', Validators.compose([Validators.required])],
      phoneNumber: ['', Validators.compose([Validators.required])],
      userName: ['', Validators.compose([Validators.required])],
      storeUrl: [''],
      vendorEmail: ['', Validators.compose([Validators.required])],
      vendorPassword:['', Validators.compose([Validators.required])],
      accountName:[''],
      accountType:[''],
      bankAdress:[''],
      iban:[''],
      accountNumber:[''],
      bankName:[''],
      routingNumber:[''],
      swift:['']
    })
  }

  /**
   * createProject()
   * - Validates form
   * - Creates a project for the vendor via BuilderService
   * - Applies default project settings
   * - Converts to manual payment project
   * - Saves vendor payload in Database under:
   *   `projects/{selectedProject}/vendors/{projectId}`
   * - Navigates back to vendor list on success
   */

  createProject = () => {
      this.builderService.showUpdateProgress = true
    if (this.isSubmitting) return; // ignore extra clicks
    if (this.vendorForm.invalid) {
      alert('Please fill all the required fields')
         this.builderService.showUpdateProgress = false
      return
    }
    this.isSubmitting = true;
    let email = this.vendorEmail
    let name = this.firstName + ' ' + this.lastName
    this.builderService.createFreeProject(email, '', false, this.vendorPassword).subscribe((response: any) => {
      (response)
      if (response.success == false) {
        alert(response.data)
           this.builderService.showUpdateProgress = false
        return
      }
      const projectId = response.project_id
      // Apply default settings for the project
      const iconImage= 'https://firebasestorage.googleapis.com/v0/b/neat-planet-378416.appspot.com/o/project_assets%2Fempty-image.png?alt=media&token=7d709042-fd20-4a8e-af0a-5c4e0fca1d57'
      this.appSettings.addProjectDefaultSettings(projectId,'vendor',iconImage).subscribe(() => {
        this.builderService.convertToManualPaymentProject(email, projectId).subscribe(() => {
          // Vendor payload stored in Firestore/Database
          const vendorPayload = {
            id: projectId,
            img: '',
            name: name || `Vendor ${projectId}`,
            email: email || '',
            creationDate: new Date().toLocaleDateString(),
            activation: true,
            // storeName: this.storeName,
            phoneNumber: this.phoneNumber,
            vendorPassword: this.vendorPassword,
            storeUrl: this.storeUrl || '',
            userName: this.userName,
            accountName: this.accountName,
            accountType: this.accountType,
            bankAdress: this.bankAdress,
            iban: this.iban,
            accountNumber: this.accountNumber,
            bankName: this.bankName,
            routingNumber: this.routingNumber,
            swift: this.swift
          }

          this.appSettingsService.upsertSettingsByType(String(this.builderService.selectedProject), 'vendor', { [projectId]: vendorPayload })
            .then(() => {
              this.isSubmitting = false
              this.vendorService.refresh()
              alert('Vendor Created Successfully, Vendor ID: ' + projectId)
                 this.builderService.showUpdateProgress = false
              this.router.navigate(['/vendors']) // list page now reads from project scope
            })
            .catch((err: any) => {
              this.isSubmitting = false
              console.error('Failed to add vendor under MultiVendor:', err)
              alert('Failed to add vendor. Please retry.')
                 this.builderService.showUpdateProgress = false
              this.router.navigate(['/vendors'])
            })
        })
      })
    })
  }
}
